import {ComputationResult} from './../computation-result';
import {Computation} from './../computation';
import {Distribution} from './../../distributions/distribution';
import {_AvailableResult} from './../available-result';

/**
 * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution
 */
export interface TestDistribution extends Computation._UnivariateComputation {
    distribution: Distribution.FittedDistribution;

    // PolyJson type
    type: 'test_distribution';
}

export function isTestDistribution(toTest: Computation): toTest is TestDistribution { return 'test_distribution' === toTest.type; }

export namespace TestDistribution {
    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$TestDistributionResult
     */
    export interface TestDistributionResult extends _AvailableResult {
        plot: TestDistribution.PlotData;
        test: TestDistribution.StatTests;

        // PolyJson type
        type: 'test_distribution';
    }

    export function isTestDistributionResult(toTest: ComputationResult): toTest is TestDistributionResult { return 'test_distribution' === toTest.type; }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$ProbabilityMassFunction
     */
    export interface ProbabilityMassFunction {
        probs: number[];
        xvals: number[];
    }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$ProbabilityDensityFunction
     */
    export interface ProbabilityDensityFunction {
        probs: number[];
        xvals: number[];
    }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$LikelihoodTestsResult
     */
    export interface LikelihoodTestsResult {
        aic?: number | null;
        aicc?: number | null;
        bic?: number | null;
        ll?: number | null;
    }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$PlotData
     */
    export interface PlotData {
        pdf?: TestDistribution.ProbabilityDensityFunction | null;
        pmf?: TestDistribution.ProbabilityMassFunction | null;
        qq: TestDistribution.QQPlotData;
    }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$KolmogorovSmirnovTestResult
     */
    export interface KolmogorovSmirnovTestResult {
        pvalue: number;
        statistic: number;
    }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$StatTests
     */
    export interface StatTests {
        ks?: TestDistribution.KolmogorovSmirnovTestResult | null;
        ll: TestDistribution.LikelihoodTestsResult;
    }

    /**
     * Generated from com.dataiku.dip.eda.compute.computations.univariate.TestDistribution$QQPlotData
     */
    export interface QQPlotData {
        empirical: number[];
        percentile: number[];
        theoretical: number[];
    }
}